import { Box } from "native-base";
import { ImageBackground } from "react-native";

type RenderItemProps = {
  item: any[];
  index: number;
};
export const RenderItem = ({ item, index }: RenderItemProps) => (
  <Box
    w={300}
    h={350}
    mb={5}
    rounded={"md"}
    margin="auto"
    key={index}
    alignSelf="center"
  >
    <ImageBackground
      source={item}
      resizeMode="cover"
      style={{
        width: "100%",
        height: "100%",
      }}
      imageStyle={{ borderRadius: 10 }}
    ></ImageBackground>
  </Box>
);
